import ViewReleasesHome from "../views/ViewReleasesHome.vue"

export default [
	{
		path: "/releases",
		component: ViewReleasesHome,
		name: "ViewReleasesHome",
		meta: {}
	}
]
